<template>
  <v-container flex>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
        <v-flex xs12>
          <v-toolbar
            color="#eee"
            class="elevation-0 secondary--text" >
            <v-toolbar-title>Tipos de Pagamento</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" width="500" lazy :fullscreen="$vuetify.breakpoint.xs" hide-overlay>
              <v-btn icon color='info' slot="activator">
                <v-icon>add</v-icon>
              </v-btn>
              <cad-tipo-pagamento @fechar="dialog = false" @info="showInfo" @error="showError"></cad-tipo-pagamento>
            </v-dialog>
          </v-toolbar>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="tiposPagHeaders"
            :items="tiposPag"
            :loading="loading"
            hide-actions
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.descricao }}</td>
              <td class="text-xs-left">{{ props.item.referencia }}</td>
              <td class="text-xs-left">
                <v-icon color="teal" v-if="props.item.cartao" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-left">
                <v-icon color="teal" v-if="props.item.especie" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-right">
                <v-btn icon flat color="info" @click="editarTipoPag(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon flat color="red" @click="apagarTipoPag(props.item)">
                  <v-icon>close</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogEditarTipoPag" width="500" lazy :fullscreen="$vuetify.breakpoint.xs">
      <editar-tipo-pag @fechar="fecharEdicao()" @info="showInfo" @error="showError"></editar-tipo-pag>
    </v-dialog>
  </v-container>
</template>

<script>
import CadTipoPagamento from '@/components/cadastros/CadTipoPagamento'
import EditarTipoPag from '@/components/dialogs/DialogEditarTipoPagamento'
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: { CadTipoPagamento, EditarTipoPag, SmartLockMessage },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogEditarTipoPag: false,
      dialog: false,
      tiposPagHeaders: [
        {
          text: 'Descrição',
          align: 'left',
          sortable: false,
          value: 'descricao'
        },
        {
          text: 'Referência do tipo de pagamento',
          align: 'left',
          sortable: false,
          value: 'referencia'
        },
        {
          text: 'Cartão',
          align: 'left',
          sortable: false,
          value: 'cartao'
        },
        {
          text: 'Em espécie',
          align: 'left',
          sortable: false,
          value: 'especie'
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  computed: {
    tiposPag () {
      return this.$store.getters.tiposPag
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    smartLock () {
      return this.$store.getters.smartLock
    }
  },
  watch: {
    headers (val) {
      if (val) {
        this.$store.dispatch('carregarTiposPagamento')
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('carregarTiposPagamento')
    }
  },
  methods: {
    editarTipoPag (tipoPag) {
      this.$store.dispatch('selectTipoPagamento', tipoPag)
      this.dialogEditarTipoPag = true
    },
    apagarTipoPag (tipoPag) {
      this.$store.dispatch('deletarTipoPagamento', tipoPag).then(() => {
        this.$store.dispatch('carregarTiposPagamento')
      })
    },
    fecharEdicao () {
      this.$store.dispatch('selectTipoPagamento', null)
      this.dialogEditarTipoPag = false
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
      this.$store.dispatch('carregarTiposPagamento')
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
